// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

export interface CheckoutContainerStyles {
    container?: InjectableCss;
    headerContainer?: InjectableCss;
    titleWrapper?: InjectableCss;
    approverMessagesWrapper?: InjectableCss;
    bodyContainer?: InjectableCss;
    topLeftContainer?: InjectableCss;
    topRightContainer?: InjectableCss;
    bottomLeftContainer?: InjectableCss;
    bottomRightContainer?: InjectableCss;
    stickyContainer?: InjectableCss;
}

// Used by checkout pages
export const checkoutContainerStyles: CheckoutContainerStyles = {
    container: {
        css: css`
            width: 100%;
        `,
    },
    headerContainer: {
        css: css`
            width: 100%;
        `,
    },
    bodyContainer: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            margin-bottom: 40px;

            @media (max-width: 1200px) {
                flex-direction: column;
            }
        `,
    },
    topLeftContainer: {
        css: css`
            width: calc(100% - 320px);
            @media (max-width: 1200px) {
                width: 100%;
                margin-bottom: 40px;
                order: 1;
            }
        `,
    },
    topRightContainer: {
        css: css`
            width: 320px;
            padding-left: 20px;
            margin-bottom: 53px;
            @media (max-width: 1200px) {
                width: 100%;
                padding-left: 0;
                order: 3;
            }
        `,
    },
    bottomLeftContainer: {
        css: css`
            width: calc(100% - 320px);
            padding-top: 36px;
            border-top: 2px solid ${getColor("common.ui3")};

            @media (max-width: 1200px) {
                width: 100%;
                margin-bottom: 40px;
                order: 2;
            }
        `,
    },
    bottomRightContainer: {
        css: css`
            width: 320px;
            padding-left: 20px;
            margin-bottom: 40px;
            @media (max-width: 1200px) {
                width: 100%;
                padding-left: 0;
                order: 4;
            }
        `,
    },
    stickyContainer: {
        css: css`
            position: sticky;
            top: 145px;
        `,
    },
    approverMessagesWrapper: {
        css: css`
            margin-bottom: 40px;
        `,
    },
};

export interface CheckoutMainElementStyles {
    sectionContainer?: InjectableCss;
    sectionHeaderContainer?: InjectableCss;
    sectionTitle?: TypographyPresentationProps;
    sectionBodyContainer?: InjectableCss;
}

export const checkoutMainElementStyles: CheckoutMainElementStyles = {
    sectionContainer: {
        css: css`
            width: 100%;
        `,
    },
    sectionHeaderContainer: {
        css: css`
            width: 100%;
            flex-basis: 100%;
            display: flex;
        `,
    },
    sectionBodyContainer: {
        css: css`
            width: 100%;

            &.flex-column {
                display: flex;
                flex-direction: column;
            }
        `,
    },
    sectionTitle: {
        variant: "h3",
    },
};
